export default __webpack_public_path__ + "static/section2_bg-14d7f0ace32f1c86a18f2221811ec34e.png";